import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { ReligionBranch } from '../components/religion-branch/religion-branch.component';
import { Localized } from '../../../objects';

@Injectable()
export class FeastTypeService {

  private cache: FeastType[];

  constructor(private apiSvc: ApiService) { }

  public loadEntites(): Promise<FeastType[]> {

    const p = new Promise<FeastType[]>((resolve, reject) => {

      if (this.cache && this.cache.length > 0) {
        console.log("FeastType cache detected");
        resolve(this.cache);
        return;
      }

      this.apiSvc.get("api/feasttype/", null).subscribe(
        (data: FeastType[]) => {
          console.log(data);
          this.cache = data;
          resolve(this.cache);
        },
        (err) => {
          console.log("error", err);
        }
      );

  });

  return p;
}

}

export class FeastType {
  Id: string;
  ReligionBranch: ReligionBranch;
  DisplayOrder: number;
  Localized: Localized[];
}
